import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';
import StoreLandingPageViewModel from './StoreLandingPageViewModel.type';

type StoreLandingPageType = StoreLandingPageViewModel & PageType;

export default (currentPage: PageType): currentPage is StoreLandingPageType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_Stores_StoreLandingPageViewModel;
};
